/**
 * The AI launcher's ring: cyan through blue into violet.
 *
 * Deliberately not a theme token. Every other accent in Lixani is a shade of
 * the current scheme's blue and changes with the theme; this gradient is the
 * one thing on screen whose job is to say "this button is the assistant", and
 * it has to read the same on all three grounds. The violet in particular
 * belongs to nothing else in the app, which is what stops the button reading as
 * one more blue control. `controlRadius.js` holds a shared control value the
 * same way.
 */
export const AI_GLOW_FROM = '#35d0f0';
export const AI_GLOW_VIA = '#4f7cff';
export const AI_GLOW_TO = '#a06cff';

/**
 * Two clocks, and they must stay apart: the ring's full turn is slow enough to
 * read as ambient, while the halo and the sparkle share a shorter beat. One
 * speed for all three reads as a loading spinner rather than as a button that
 * is simply alive.
 */
export const AI_GLOW_TURN = '6s';
export const AI_GLOW_BEAT = '2.6s';
